import { useNavigate } from "react-router-dom";
import Modal from "components/atoms/modal";
import Btn from "components/atoms/buttons";
import { H4, TextSm } from "components/atoms/text";

interface Props {
  userName: string;
}

// 아이디찾기 성공 시 모달
const ModalFindID = ({ userName }: Props) => {
  const navigate = useNavigate();

  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <H4 className="mb-3">ID 찾기</H4>
      <TextSm className="text-black-60% mb-5">
        회원님의 아이디는
        <br />
        {userName} 입니다.
      </TextSm>
      <Btn.Blue
        onClick={() => navigate("/login")}
        size="large"
        className="w-full"
      >
        닫기
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalFindID;
